import Thankpage from 'components/Thank/Thankpage';

function ThankYou() {
    return (
        <Thankpage />
    ) 
}

export default ThankYou;